<template>
  <div class="widget-sea">
    <div class="card owl-item text-white bg-dark" style="height: 40rem; margin-right: 5px;">

      <div class="card-header" style="max-height: 2.3rem; padding-top: 0.25rem;"><h5>Estat de la mar <small> - darreres dades </small></h5></div>

      <svg class="svg-inline--fa fa-water fa-w-18 fa-2x" style="position: absolute;  color: Aqua; right: 0.5rem; top: 0.2rem; z-index: 1;" aria-hidden="true" focusable="false" data-prefix="fas" data-icon="water" role="img" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 576 512" data-fa-i2svg=""><path fill="currentColor" d="M562.1 383.9c-21.5-2.4-42.1-10.5-57.9-22.9-14.1-11.1-34.2-11.3-48.2 0-37.9 30.4-107.2 30.4-145.7-1.5-13.5-11.2-33-9.1-46.7 1.8-38 30.1-106.9 30-145.2-1.7-13.5-11.2-33.3-8.9-47.1 2-15.5 12.2-36 20.1-57.7 22.4-7.9.8-13.6 7.8-13.6 15.7v32.2c0 9.1 7.6 16.8 16.7 16 28.8-2.5 56.1-11.4 79.4-25.9 56.5 34.6 137 34.1 192 0 56.5 34.6 137 34.1 192 0 23.3 14.2 50.9 23.3 79.1 25.8 9.1.8 16.7-6.9 16.7-16v-31.6c.1-8-5.7-15.4-13.8-16.3zm0-144c-21.5-2.4-42.1-10.5-57.9-22.9-14.1-11.1-34.2-11.3-48.2 0-37.9 30.4-107.2 30.4-145.7-1.5-13.5-11.2-33-9.1-46.7 1.8-38 30.1-106.9 30-145.2-1.7-13.5-11.2-33.3-8.9-47.1 2-15.5 12.2-36 20.1-57.7 22.4-7.9.8-13.6 7.8-13.6 15.7v32.2c0 9.1 7.6 16.8 16.7 16 28.8-2.5 56.1-11.4 79.4-25.9 56.5 34.6 137 34.1 192 0 56.5 34.6 137 34.1 192 0 23.3 14.2 50.9 23.3 79.1 25.8 9.1.8 16.7-6.9 16.7-16v-31.6c.1-8-5.7-15.4-13.8-16.3zm0-144C540.6 93.4 520 85.4 504.2 73 490.1 61.9 470 61.7 456 73c-37.9 30.4-107.2 30.4-145.7-1.5-13.5-11.2-33-9.1-46.7 1.8-38 30.1-106.9 30-145.2-1.7-13.5-11.2-33.3-8.9-47.1 2-15.5 12.2-36 20.1-57.7 22.4-7.9.8-13.6 7.8-13.6 15.7v32.2c0 9.1 7.6 16.8 16.7 16 28.8-2.5 56.1-11.4 79.4-25.9 56.5 34.6 137 34.1 192 0 56.5 34.6 137 34.1 192 0 23.3 14.2 50.9 23.3 79.1 25.8 9.1.8 16.7-6.9 16.7-16v-31.6c.1-8-5.7-15.4-13.8-16.3z"></path></svg>
      
      <img class="card-img-top" style="max-height: 35rem; min-height: 35rem; object-fit: cover;" src="http://www.portdebarcelona.cat/whatsup/static/APB/meteo/FAVPortBcn3d-Ones.jpg">

      <div class="card-body" style="min-height: 35rem; max-height: 35rem; display: flex;  flex-direction: column;  justify-content: center; padding: 0.2rem;">
        <div class=" text-center border m-0 p-0" style="max-height: 30rem; min-height: 30rem; position:absolute;  right: 0.5rem; bottom:4rem; z-index: 2; width: 9rem;">
          <div class="text-center text-dark font-weight-bold m-0 p-0 bg-white" style="font-size:1.2rem; line-height: 120%;">
            Onatge {{ data.horautc }}h UTC
          </div>
          <div>
            <div class="container text-white">
              <div class="row">
                <div class=" p-0 pr-1">
                  <div class="text-white m-0 mt-2 p-0" style="font-size: 1.1rem; line-height: 90%; "><b>Direcció:</b> </div>
                  <div class="text-white m-0 mt-2 p-0" style="font-size: 1.8rem; line-height: 90%; "><b>{{ data.onesdireccio }}</b>º</div>
                  <img :src=data.onessimboldireccio class="m-0 mt-2 p-0" style="max-height:7rem; min-height:7rem;">
                  <p></p>
                  <div class="container m-0 mt-1 mb-3 p-0">
                    <div class="rounded-lg border border-white text-white p-2 m-2" style="position:relative; font-size: 2.5rem; line-height: 70%; border-width: 3px !important;">
                            <b>{{ data.onesaltsignicant }}</b><small>m</small>
                              <div class="m-0 mt-1 p-0 text-white" style="text-align: center; font-size: 0.9rem; line-height: 90%;">Altura Signif.</div>
                    </div>
                    <table class="table table-lg table-borderless m-0 mt-1 p-0 text-white">
                              <tbody>
                                <tr>
                                  <td class="m-0 p-0" style="text-align: right; font-size: 0.9rem; line-height: 90%;">Període<br>mig</td>
                                  <td class="m-0 p-0 pl-1" style="text-align: left; font-size: 1.4em; line-height: 90%;"><b>{{ data.onesperiodemig }}</b>s</td>
                                </tr>
                                <tr>
                                  <td class="m-0 p-0 pt-1" style="text-align: right; font-size: 0.9rem; line-height: 90%;">Període<br>de pic</td>
                                  <td class="m-0 p-0 pl-1 pt-1" style="text-align: left; font-size: 1.4em; line-height: 90%;"><b>{{ data.onesperiodepic }}</b>s</td>
                                </tr>
                              </tbody>
                          </table>
                  </div>
                      
                </div>
              </div>
            </div>              
          </div>
        </div>
      </div>


      <div class="card-footer m-0 ml-1  p-0" style="max-height: 1.5rem; position:absolute; bottom: 0.8rem; left:0.1rem; z-index: auto; ">
          <span class="badge badge-secondary border border-white align-self-sm-end">Informació dels sensors del Port de Barcelona <br>i de Puertos del Estado  </span>
        </div>
    </div>
  </div>
</template>
<script>
export default {
  name: 'Sea',
  props: {
    data: Object
  }
}
</script>